(function ($) {
  "use strict";

  /* Cart scripts */
document.addEventListener("DOMContentLoaded", function (event) {
  const payment = document.querySelector('.wc-proceed-to-checkout.text-center')
  console.log(payment)
  if (payment){
    payment.insertBefore(payment.querySelector('.woocommerce-checkout'), payment.firstChild)
  }
})

  $(document).on('change', 'input[type="number"]', function(e) {
    const $zineQty = $(this).parents('.zineQty');

    if ($zineQty.length) {
      $zineQty.find('.zineQty_number').html(e.target.value);
    }
  });

  $(document).on('click', '.zineQty_plus', function(e) {
    const $input = $(this).parents('.zineQty').find('input');

    if ($input.length) {
      $input[0].stepUp();
      $input.trigger('change');
    }
  });

  $(document).on('click', '.zineQty_minus', function(e) {
    const $input = $(this).parents('.zineQty').find('input');

    if ($input.length) {
      $input[0].stepDown();
      $input.trigger('change');
    }
  });


})(jQuery);